import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Disable browser scroll restoration (THIS is the missing piece)
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Immediate
    scrollToTop();

    // Timeout pass
    const t1 = setTimeout(scrollToTop, 0);
    const t2 = setTimeout(scrollToTop, 50);

    // Double RAF (beats mobile rendering timing)
    const raf1 = requestAnimationFrame(() => {
      scrollToTop();

      requestAnimationFrame(() => {
        scrollToTop();
      });
    });

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      cancelAnimationFrame(raf1);
    };
  }, [
    location.pathname,
    location.search,
    location.hash,
    location.key, // VERY important
  ]);

  return null;
}